import { useSyncExternalStore } from 'react';

const TABLET_MIN_BREAKPOINT = 768;
const TABLET_MAX_BREAKPOINT = 1440;

export const TABLET_QUERY = `(min-width: ${TABLET_MIN_BREAKPOINT}px) and (max-width: ${TABLET_MAX_BREAKPOINT - 1}px)`;

const getIsTablet = () =>
  window.innerWidth >= TABLET_MIN_BREAKPOINT &&
  window.innerWidth < TABLET_MAX_BREAKPOINT;
const getServerSnapshot = () => false;

/** True in the 768–1439px band — wide enough for the desktop layout, too narrow
    to keep the sidebar expanded. */
export function useIsTablet() {
  const isTablet = useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(TABLET_QUERY);
      mql.addEventListener('change', callback);
      return () => mql.removeEventListener('change', callback);
    },
    getIsTablet,
    getServerSnapshot,
  );

  return isTablet;
}
